import { useRef, useCallback } from 'react';

const useInfiniteScroll = (callback, hasMore, loading) => {
  const observerRef = useRef();
  
  const lastElementRef = useCallback(node => {
    if (loading) return; // Don't trigger if already loading
    
    if (observerRef.current) observerRef.current.disconnect();
    
    observerRef.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore && !loading) {
        callback();
      }
    }, {
      rootMargin: '100px' // Start loading 100px before reaching the bottom
    });
    
    if (node) observerRef.current.observe(node);
  }, [callback, hasMore, loading]);
  
  return lastElementRef;
};

export default useInfiniteScroll; 